import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonParticipantImagesApi } from "api/api/marathonParticipantImagesApi/marathonParticipantImages";
import axios from "axios";

export const getMarathonParticipantImageByFileId = createAsyncThunk<
  string,
  string
>(
  "marathons/getMarathonParticipantImageByFileId",
  async (fileId, { rejectWithValue }) => {
    try {
      const blob =
        await MarathonParticipantImagesApi.getMarathonParticipantImageByFileId(fileId);

      const url = URL.createObjectURL(blob);

      return url;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error?.response?.data);
      }
      return rejectWithValue("Unknown error");
    }
  }
);